// extracted by mini-css-extract-plugin
export var dot = "_px-2";
export var wave = "_px-0";
export var waveSmall = "_px-1";